import React from "react";
import NoResults from "../../../../components/noResults/NoResults";

const ContentGroupsNoResults: React.FC = () => (
  <NoResults title="You don't have any added groups yet" iconClassName="fal fa-users" />
);

export default ContentGroupsNoResults;
